import gql from "graphql-tag";

export default gql`
  query groupDiscountCodeForSchoolOnboarding($code: String!) {
    groupDiscountCodeForSchoolOnboarding(code: $code) {
      id
    }
  }
`;


// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/gql/groupDiscountCodeForSchoolOnboarding.query.js